import ElementUI, { MessageBox,Notification, Message,Loading} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
let flag=true
var body =document.querySelector('body')
var div=document.createElement('div')
    div.style.height='100vh'
    div.style.width='100vw'
    div.style.position='fixed'
    div.style.top='0'
    div.style.left='0'
// let timeer
    // div.style.backgroundColor='#666'
export function rejecthttp(block,type,url,params,that,cb){
  let c={}
  let messageLan=that.$i18n.locale=='cn'?'加载失败':'error'
    if(block){
        changeflag()
        c.timeer=setTimeout(() => {
            // if(!flag){
              try{
                c.loading=Loading.service({ fullscreen: true })
                body.removeChild(div)
                flag=!flag
              }
                catch(e){
                  console.log(e);
                }
              // }
        }, 2000);
        c.timeer2=setTimeout(() => {
          // if(!flag){
            try{
              if(c.loading){
                c.loading.close()
              }
              // c.loading.close()
              Message({
                type: "error",
                message: messageLan,
              });
              body.removeChild(div)
              flag=!flag
            }
              catch(e){
                console.log(e);
              }
            // }
      }, 10000);
        if(type=='get'){
            return that.$http[type](url,{params:params}).then((doc)=>{
              try{
                if(c.loading){
                  c.loading.close()
                }
              }
              catch(e){
                console.log(e);
              }
              clearTimeout(c.timeer)
              clearTimeout(c.timeer2)
              cb(doc)
            })
        }else if(type=='post'){
          return that.$http[type](url,params).then((doc)=>{
            try{
              if(c.loading){
                c.loading.close()
              }
            }
            catch(e){
              console.log(e);
            }
            clearTimeout(c.timeer)
            clearTimeout(c.timeer2)
            cb(doc)
          })
      }else if(type=='delete'){
        
        return that.$http[type](url,params).then((doc)=>{
          try{
            if(c.loading){
              c.loading.close()
            }
          }
          catch(e){
            console.log(e);
          }
          clearTimeout(c.timeer)
          clearTimeout(c.timeer2)
          cb(doc)
        })
    }
    }else{
        if(type=='get'){
            return that.$http[type](url,{params:params}).then(cb)
        }else if(type=='post'){
          return that.$http[type](url,params).then(cb)
        }else if(type=='delete'){
          return that.$http[type](url,params).then(cb)
        }else if(type=='getFileUpload'){
          return that.$http['post'](url,params,{headers: { 'content-type': 'multipart/form-data' }}).then(cb)
        }
        
    }
    return new Promise()
}

 function changeflag(){
     flag=!flag
    body.appendChild(div)
}
export function changeflagCLOSED(doc,message,that) {
  console.log(that.$i18n.locale);

    try{

      let messageLan=that.$i18n.locale=='cn'?doc.data.Message:doc.data.MessageEng
        // changeflagCLOSED()
        // if(message){
      if (doc.data.Code != "MSGKEY_OK") {
        Message({
          type: "error",
          message: messageLan,
        });
      } else {
        if(message){
          if (doc.data.Code != "MSGKEY_OK") {
            Message({
              type: "error",
              message: messageLan,
            });
          } else {
            Message({
              type: "success",
              message: messageLan,
            });
          }
          
        }
      }
      
        body.removeChild(div)
        flag=!flag
    }catch(e){
      console.log(e);
    }
}
export function changeflagCLOSED1234() {
    try{
        // changeflagCLOSED()
        body.removeChild(div)
      
      // if(!flag){
        body.removeChild(div)
        flag=!flag
      // }
    }catch(e){
      console.log(e);
    }
}
export function Loadingdata (){
  return Loading
}


// WEBPACK FOOTER //
// ./src/utils/request.js